export type LojaIntegradaOverviewMessages = {
  lojaIntegradaOverviewText1: string;
  lojaIntegradaOverviewText2: string;
};

export const lojaIntegradaOverviewMessages: LojaIntegradaOverviewMessages = {
  lojaIntegradaOverviewText1: "Conecte sua conta agora mesmo com a plataforma Loja Integrada!",
  lojaIntegradaOverviewText2: "Siga  os próximos passos para conectar sua conta.",
};
